function setCookie(name, value, day) {
  var day = day || 1
  var exp = new Date()
  exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000)
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/;domain=cocofax.com'
}

const getCookie = (name) => {
  var strcookie = document.cookie //获取cookie字符串
  var arrcookie = strcookie.split('; ') //分割
  //遍历匹配
  for (var i = 0; i < arrcookie.length; i++) {
    var arr = arrcookie[i].split('=')
    if (arr[0] === name) {
      return arr[1]
    }
  }
  return ''
}

const delCookie = (name) => {
  var exp = new Date()
  exp.setTime(exp.getTime() - 1)
  var cval = getCookie(name)
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + ';path=/;domain=cocofax.com'
  }
}

const getCookieToken = () => {
  return getCookie('cocofaxToken')
}

const clearUserCookie = () => {
  delCookie('cocofaxToken')
  delCookie('cocofaxName')
}

export { setCookie, getCookie, delCookie, clearUserCookie, getCookieToken }
